import React from "react"
import styled from "styled-components"
import moment, {Moment} from "moment"

import {H5} from "@irati/ui/src/Typography"
import {FormattedMessage, FormattedDate} from "@irati/utils/lang"
import id from "@irati/utils/id"

const StyledH5 = styled(H5)`
  display: inline-block;
`

interface Props {
  date: Moment
  id?: string
}
const getFormattedDate = (date: Moment) => {
  const startOfDate = date.startOf("day")
  const today = moment().clone().startOf("day")
  const yesterday = moment().clone().subtract(1, "days").startOf("day")
  if (startOfDate.isSame(today)) {
    return <FormattedMessage id="platform.dateHeader.today" />
  } else if (startOfDate.isSame(yesterday)) {
    return <FormattedMessage id="platform.dateHeader.yesterday" />
  }
  return <FormattedDate value={startOfDate.toDate()} weekday="long" year="numeric" month="long" day="numeric" />
}
const DateHeader = (props: Props) => {
  return (
    <StyledH5 marginBottom={1} id={id("date-header", props)}>
      {getFormattedDate(props.date)}
    </StyledH5>
  )
}
export default DateHeader
